<section class="container">
  <div class="flex flex-row justify-between items-start mb-4">
    <rfc-heading-widget [headingName]="defineTitleAndDescriptionWidgetObj('disclaimer_modal')"></rfc-heading-widget>
  </div>

  <mat-card class="p-4 mat-custom-card mat-custom-card-shadow">
    <rfc-read-more [text]="data?.text" [maxLength]="isMobile ? 100 : undefined"></rfc-read-more>
  </mat-card>

  <div class="flex flex-col-reverse md:flex-row justify-center items-center gap-[2em] mt-4 mb-4">
    <button mat-raised-button (click)="onClose()" class="ald-mat-button primary w-full md:w-auto">
      {{ "apply" | i18n }}
    </button>
  </div>
</section>
